module.exports = function() {
  return new Worker("/" + "babel-transpiler.fb53ec83.worker.js");
};